import { render, staticRenderFns } from "./WebPagesNewsBlockForm.vue?vue&type=template&id=3de06789&"
import script from "./WebPagesNewsBlockForm.vue?vue&type=script&lang=js&"
export * from "./WebPagesNewsBlockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports